import { useState, useCallback } from 'react';
import {
  useGetSignedConsentModulesQuery,
  useUpdateConsentModuleSignatureMutation,
} from 'services/settingsService';
import { SignedConsentModule } from '../types/types';

export const useSecuritySettings = () => {
  const { data: modulesData } = useGetSignedConsentModulesQuery();
  const [updateConsentSignature, { isError: isSignatureError, reset: resetSignatureError }] =
    useUpdateConsentModuleSignatureMutation();

  const [modules, setModules] = useState<SignedConsentModule[] | undefined>(modulesData);

  const displayModules = modules ?? modulesData;

  const updateModule = useCallback(
    (moduleId: number, updates: Partial<SignedConsentModule>) => {
      setModules((prev) => {
        const base = prev ?? modulesData;
        return base?.map((m) => (m.id === moduleId ? { ...m, ...updates } : m));
      });
    },
    [modulesData],
  );

  const handleSignatureChange = useCallback(
    (moduleId: number, consented: boolean) => {
      updateModule(moduleId, { consented, answered_date: Math.floor(Date.now() / 1000) });

      updateConsentSignature({ moduleId, consented })
        .then(({ data, error }) => {
          if (error) {
            updateModule(moduleId, { consented: !consented });
            return;
          }
          const signature = data?.find((sig) => sig.module_id === moduleId);
          if (signature) {
            updateModule(moduleId, { answered_date: signature.answered_date });
          }
        })
        .catch(() => updateModule(moduleId, { consented: !consented }));
    },
    [updateConsentSignature, updateModule],
  );

  return { modules: displayModules, isSignatureError, resetSignatureError, handleSignatureChange };
};
